import { getPrimaryMailFolders } from 'owa-folders';
import onMessageClassificationsResponse from '../actions/actionCreators/onMessageClassificationsResponse';
import initializeInboxRulesEditData from '../actions/actionCreators/initializeInboxRulesEditData';
import { orchestrator } from 'satcheljs';
import initializeInboxRulesFolderStore from '../actions/actionCreators/initializeInboxRulesFolderStore';
import getMessageClassificationOperation from 'owa-service/lib/operation/getMessageClassificationOperation';

/**
 * Makes the find folder service call and adds the folders to the create/edit inbox rule store
 */
orchestrator(initializeInboxRulesEditData, actionMessage => {
    // Initialize the 'owa-folders' folder store if the user is visiting the rules
    // option page from a non-mail module
    getPrimaryMailFolders();

    // Set up the rules folder store from using the 'owa-folders' store
    initializeInboxRulesFolderStore();
});

/**
 * Makes the get message classification service call and adds the classifications to the create/edit inbox rule store
 */
orchestrator(initializeInboxRulesEditData, async actionMessage => {
    const getMessageClassificationResponse = await getMessageClassificationOperation();

    if (getMessageClassificationResponse && getMessageClassificationResponse.WasSuccessful) {
        onMessageClassificationsResponse(
            getMessageClassificationResponse.MessageClassificationCollection.MessageClassifications
        );
    }
});
